import React from 'react'
import MainService from '../Components/MainService'
import Navbar from '../Components/Navbar'

function Services() {
  return (
    <>
    <Navbar />
    <MainService />
    </>
  )
}

export default Services